import { CircularProgress, Stack } from '@mui/material';
import React, { useMemo, useRef, useState } from 'react';
import DashboardBox from '../components/DashboardBox';
import CreateEditSubjectDialog from '../components/dialog/CreateEditSubjectDialog';
import ApiTable from '../components/table/ApiTable';
import SubjectUtil from '../utils/SubjectUtil';
import OutlinedIconButton from '../components/button/OutlinedIconButton';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import AddIcon from '@mui/icons-material/Add';
import ContainedIconButton from '../components/button/ContainedIconButton';

const Subjects = () => {
  const [showAddDialog, setShowAddDialog] = useState(false);
  const [loading, setLoading] = useState(true);
  const [subjectToEdit, setSubjectToEdit] = useState(null);
  const tableRef = useRef();
  const columns = useMemo(
    () => [
      {
        header: 'Vak',
        accessor: 'name',
      },
      {
        header: 'Afkorting',
        accessor: 'abbreviation',
      },
      {
        header: 'Acties',
        Cell: ({ value }) => (
          <Stack direction="row" spacing={1}>
            <OutlinedIconButton onClick={() => setSubjectToEdit(value)}>
              <EditIcon />
            </OutlinedIconButton>
            <ContainedIconButton color="error" onClick={() => deleteSubject(value)}>
              <DeleteIcon />
            </ContainedIconButton>
          </Stack>
        ),
      },
    ],
    [],
  );

  const deleteSubject = subject => {
    setLoading(true);
    SubjectUtil.deleteSubject(subject.id).finally(() => {
      tableRef.current?.loadData();
    });
  };

  const handleCreateSubjectClosed = subject => {
    if (subject) {
      tableRef.current?.loadData();
    }
    setShowAddDialog(false);
    setSubjectToEdit(null);
  };

  return (
    <Stack>
      <DashboardBox sx={{ width: '33%' }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Stack direction="row" alignItems="center" spacing={1}>
            <p className="title">Vakken</p>
            {loading && <CircularProgress size={16} />}
          </Stack>
          <ContainedIconButton onClick={() => setShowAddDialog(true)}>
            <AddIcon />
          </ContainedIconButton>
        </Stack>
        <ApiTable
          apiSource={SubjectUtil.getSubjects}
          columns={columns}
          enablePagination={false}
          setLoading={setLoading}
          ref={tableRef}
        />
      </DashboardBox>
      {subjectToEdit !== null && (
        <CreateEditSubjectDialog subject={subjectToEdit} open={true} onClose={handleCreateSubjectClosed} />
      )}
      {showAddDialog && <CreateEditSubjectDialog open={true} onClose={handleCreateSubjectClosed} />}
    </Stack>
  );
};

export default Subjects;
